import {createContext, useContext, useEffect, useState} from "react";
import {authContext} from "./auth";
import {useParams} from "react-router-dom";
import filterResponse from "../filterResponse";

export const progressContext = createContext({
	progress: {},
	setProgress: (progress) => {}
});

export function ProgressProvider({children}) {
	const [progress, setProgress] = useState({
		done: 0,
		minRows: 0,
		maxRows: 0,
		qaErrors: 0
	});
	const [loading, setLoading] = useState(true);

	const { user} = useContext(authContext);
	const {id} = useParams();

	useEffect(() => {
		(async () => {
			await getProgress();
		})();
	}, []);

	async function getProgress() {
		setLoading(true);

		try {
			const urlParams = new URLSearchParams();
			urlParams.append('freelancerId', user.id);
			urlParams.append('crowdJobId', id);
			const response = await fetch(process.env.REACT_APP_ENDPOINT + '/crowdJobSubmissions/progress?' + urlParams.toString(), {
				method: "GET",
				credentials: "include"
			});
			await filterResponse(response);

			if (response.status === 200) {
				const json = await response.json();
				setProgress(json);
			}
			else {
				throw new Error("Wrong status code.");
			}
		}
		catch (e) {
			console.error(e);
		}
		finally {
			setLoading(false);
		}
	}

	return (
		<progressContext.Provider value={{
			loading,
			progress,
			getProgress
		}}>
			{children}
		</progressContext.Provider>
	);
}
